import type { IFetchReturnOrder } from "../types/api/return";

interface IProps {
  storeName: string;
  domain?: "kr" | "intl" | "";
  returnId: string;
  customerId: string;
  returnRefundLineItems: { returnLineItemId: string; quantity: number }[];
  refundShippingFee: number;
  refundDuties?: { dutyId: string; refundType: string }[];
}

// common_get_return_order_v2
export const fetchReturnOrder = async ({
  storeName,
  domain = "",
  returnId,
  customerId,
  returnRefundLineItems = [],
  refundShippingFee,
  refundDuties = [],
}: IProps): Promise<IFetchReturnOrder | undefined> => {
  const url = "https://e3xxcumqzbbcovj2twqhkamrei0fvnvk.lambda-url.ap-northeast-2.on.aws/";

  try {
    const response = await fetch(url, {
      method: "POST",
      body: JSON.stringify({ returnId, storeName, domain, customerId, returnRefundLineItems, refundDuties, refundShippingFee }),
    }).then((res) => res);

    if (response.status === 200) {
      return (await response.json()) as IFetchReturnOrder;
    }
  } catch (error) {
    const message = error instanceof Error ? error.message : String(error);
    throw new Error(message);
  }
};
